import { DOCUMENT } from '@angular/common';
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LanguageService } from '@gs/shared/services';

@Component({
  imports: [RouterModule],
  selector: 'gs-root',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.component.html'
})
export class AppComponent {
  private readonly languageService = inject(LanguageService);
  private readonly document = inject(DOCUMENT);

  constructor() {
    // Use effect to reactively update HTML lang attribute when language changes
    effect(() => {
      const lang = this.languageService.langAttribute();
      if (lang) {
        this.document.documentElement?.setAttribute('lang', lang);
      }
    });
  }
}
